module.exports = __webpack_public_path__ + "img/vbf.71cac692.webp";